export default [
  {
    path: "/report/golddashboard",
    name: "golddashboard",
    component: () => import("@/views/document/golddashboard/index.vue"),
    meta: {
      pageTitle: "Zolotomaty",
      breadcrumb: [
        {
          text: "Report",
        },
        {
          text: "Zolotomaty",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/preciousmetalratereport",
    name: "preciousmetalratereport",
    component: () => import("@/views/report/preciousMetalRateReport/index.vue"),
    meta: {
      pageTitle: "PreciousMetalRateReport",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PreciousMetalRateReport",
          active: true,
        },
      ],
    },
  },
]
